__turbopack_context__.v({
  "activeTab": "features-module__vGqXRG__activeTab",
  "fadeIn": "features-module__vGqXRG__fadeIn",
  "featureCard": "features-module__vGqXRG__featureCard",
  "featureContent": "features-module__vGqXRG__featureContent",
  "featureDescription": "features-module__vGqXRG__featureDescription",
  "featureDetail": "features-module__vGqXRG__featureDetail",
  "featureIconContainer": "features-module__vGqXRG__featureIconContainer",
  "featureList": "features-module__vGqXRG__featureList",
  "featureTabs": "features-module__vGqXRG__featureTabs",
  "featureText": "features-module__vGqXRG__featureText",
  "featureTitle": "features-module__vGqXRG__featureTitle",
  "featureVisual": "features-module__vGqXRG__featureVisual",
  "featuresSection": "features-module__vGqXRG__featuresSection",
});
